// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"CreateGameStatsPage_pageContainer__1mwKR","icons":"CreateGameStatsPage_icons__2x9KS","formRow":"CreateGameStatsPage_formRow__vzbkk"};